<div class="popup_main_div close_year_accounts" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 cdkDragHandle matDialogTitle class="mat-dialog-header">
    <span>Close Year Accounts</span>
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography" style="overflow: hidden !important">
    <div class="one iner-scroll-class" fxLayout="column" fxLayoutAlign="start">
      @if (isLoadingResults) {
        <div class="example-loading-shade" style="z-index: 99999">
          <mat-spinner></mat-spinner>
        </div>
      }

      <div class="popup_body mt-4">
        <div align="center" class="pb-4">
          This process will finalise the accounts for the period.
        </div>
        <div align="center" class="pb-4">
          Make sure you have run your trial balance and made all subsequent adjustment entries as
          necessary.
        </div>
        <div align="center" class="pb-4 font-semibold">
          please speak to your accountant for further information on this process
        </div>
      </div>
      <div class="popup_body">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field
            class="example"
            appearance="outline"
            fxFlex="50"
            [ngClass]="{
              'has-error': $safeNavigationMigration(errorWarningData.Error?.PERIODENDDATE),
              'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PERIODENDDATE),
            }"
          >
            <mat-label>Last Day Of Period</mat-label>
            <input
              matInput
              [matDatepicker]="CalculateUpto"
              placeholder="Last Day Of Period"
              name="DATE"
              (dateChange)="choosedDate('change', $event)"
            />
            <mat-datepicker-toggle matSuffix [for]="CalculateUpto"></mat-datepicker-toggle>
            <mat-datepicker #CalculateUpto></mat-datepicker>
          </mat-form-field>
          <mat-label fxFlex="50" class="pl-12">Last Closed Date : {{ lastDate }}</mat-label>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-tab-group mat-align-tabs="start">
            <mat-tab label="Current Balances" *ngIf="!isJournalEntry">
              <div class="item_pad">
                <div class="example-containerdata">
                  <ejs-treegrid
                    #treegrid
                    [dataSource]="dataTreeTable"
                    allowSelection="true"
                    childMapping="SUBACCOUNTS"
                    [treeColumnIndex]="0"
                    [selectedRowIndex]="1"
                    [allowPaging]="false"
                    allowResizing="true"
                    [allowSorting]="true"
                    (dataBound)="dataBound()"
                    [selectionSettings]="selectionSettings"
                  >
                    <e-columns>
                      <e-column headerText="Account Name" width="200" textAlign="Left">
                        <ng-template #template let-data>
                          <label>{{ data.ACCOUNTDESC }}</label>
                        </ng-template>
                      </e-column>
                      <e-column headerText="Type" width="80">
                        <ng-template #template let-data>
                          <label>{{ data.ACCOUNTTYPE }}</label>
                        </ng-template>
                      </e-column>
                      <e-column headerText="Balance" width="80">
                        <ng-template #template let-data>
                          <label>{{ data.DISPLAYBALANCE }}</label>
                        </ng-template>
                      </e-column>
                    </e-columns>
                  </ejs-treegrid>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Closing Journal Entry" *ngIf="isJournalEntry">
              <div class="item_pad">
                <div class="example-containerdata">
                  <ejs-treegrid
                    #treegrid2
                    [dataSource]="closePeriodItem"
                    allowSelection="true"
                    childMapping="SUBACCOUNTS"
                    [treeColumnIndex]="0"
                    [selectedRowIndex]="1"
                    [allowPaging]="false"
                    allowResizing="true"
                    [allowSorting]="true"
                    (dataBound)="dataBound()"
                    [selectionSettings]="selectionSettings"
                  >
                    <e-columns>
                      <e-column headerText="Description" width="200" textAlign="Left">
                        <ng-template #template let-data>
                          <label>{{ data.DESCRIPTION }}</label>
                        </ng-template>
                      </e-column>
                      <e-column headerText="Credit" width="80">
                        <ng-template #template let-data>
                          <label>
                            {{ data.CREDITAMOUNT | toFixedAmount: true }}
                          </label>
                        </ng-template>
                      </e-column>
                      <e-column headerText="Debit" width="80">
                        <ng-template #template let-data>
                          <label>
                            {{ data.DEBITAMOUNT | toFixedAmount: true }}
                          </label>
                        </ng-template>
                      </e-column>
                    </e-columns>
                  </ejs-treegrid>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
    <div class="document_generated_main_div my-3 w-full px-0">
      <div align="right" class="text-bold mt-4">
        @if (!isJournalEntry) {
          <button
            class="mr-4"
            matButton="filled"
            color="primary"
            (click)="isJournalEntry = !isJournalEntry"
          >
            Next
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
        }
        @if (isJournalEntry) {
          <button
            class="mr-4"
            matButton="filled"
            color="primary"
            (click)="isJournalEntry = !isJournalEntry"
          >
            <mat-icon>navigate_before</mat-icon>
            Previous
          </button>
        }
        @if (isJournalEntry) {
          <button
            class="mr-4"
            matButton="filled"
            color="primary"
            [disabled]="isspiner"
            (click)="PeriodEndDatePeriodEndDate()"
          >
            <mat-spinner *ngIf="isspiner" diameter="18"></mat-spinner>
            <mat-icon>done</mat-icon>
            Finish
          </button>
        }
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="popup_ftr justify-end!">
    <div class="right_popup_btn">
      <button matButton="tonal" [mat-dialog-close]="true">Cancel</button>
    </div>
  </mat-dialog-actions>
</div>
